'use es6';

export const RECEIVE_PORTAL_SETTINGS = 'RECEIVE_PORTAL_SETTINGS';
export const UPDATE_PORTAL_SETTINGS = 'UPDATE_PORTAL_SETTINGS';
export const DELETE_PORTAL_SETTING = 'DELETE_PORTAL_SETTING';
export const RECEIVE_TRACKING_CONFIG = 'RECEIVE_TRACKING_CONFIG';
export const FETCH_DATA_PRIVACY_SETTINGS_SUCCESS = 'FETCH_DATA_PRIVACY_SETTINGS_SUCCESS';